const COMPANY_DATA = {
  COMPANY_NAME: 'TrustMate S.A.',
  COMPANY_STREET: 'Bartoszowicka 3',
  COMPANY_ZIP_CODE: '51-641 Wrocław',
  BOK_EMAIL: 'oi.etamtsurt@troppus', // use EMAIL FUNCTION
  R_EMAIL: 'oi.etamtsurt@iksrohleim.skam',
  ASSET: '2.768.000',
  PHONE: '600 080 777',
  RODO_EMAIL: 'oi.etamtsurt@rpdg',
  FACEBOOK: 'https://www.facebook.com/trustmate.io/',
  LINKEDIN: 'https://pl.linkedin.com/company/trustmate',
  INSTAGRAM: 'https://www.instagram.com/trustmate/',
  PRIVACY_POLICY_LAST_UPDATE: '05.12.2018',
  COMPANY_ASSETS: '2.843.170',
  COMPANY_REGULATIONS: 'https://cdn.trustmate.io/TrustMate_Company_Regulations_PL.pdf',
  COMPANY_REGULATIONS_EN: 'https://cdn.trustmate.io/TrustMate_Company_Regulations_EN.pdf',
  USER_REGULATIONS: 'https://cdn.trustmate.io/TrustMate_User_Regulations_PL.pdf',
  USER_REGULATIONS_EN: 'https://cdn.trustmate.io/TrustMate_User_Regulations_EN.pdf',
  PRODUCT_NAME_DOMAIN: 'TrustMate.io',
  SAFETY_EMAIL_ADDRESS: 'lp.gro.ork@owtsnezceipzeb',
  BUSINESS_REGULATIONS_LAST_UPDATE_DATE: '09.01.2019r',
  USER_REGULATIONS_LAST_UPDATE_DATE: '09.01.2019r',
  PRIVACY_POLICY_LAST_UPDATE_DATE: '05.12.2018r',
  ADDRESS_COMPANY: 'TrustMate S.A.',
  ADDRESS_STREET: 'Bartoszowicka 3',
  ADDRESS_POST: '51-641 Wrocław',
  COMPANY_PHONE: '600 080 777',
  PARTNERS_PATH: '/partnerzy',
  CLIENT_SUPPORT_EMAIL: 'support@trustmate.io',
};

export default COMPANY_DATA;
